
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import React, {useEffect, useState} from 'react';
import {useRouter} from 'next/router'
import Layout from "../components/sidebarPro";
import styles from '../assets/css/start.module.css'
import DropdownGetLevels from "../components/start/dropDownGetLevels";
import DropdownLesson from "../components/start/dropDownLessons";
import DropDownBooks from "../components/start/dropDownBooks";
import Footer from "../components/footer/Footer";
import ErrorModal from "../components/modals/loginErrorModal";
import {createGame, getBooks, getLessons,start} from "../api/requests";
import ButtonLoading from "../components/buttonLoading";
import Head from "next/head";
import useTranslation from "next-translate/useTranslation";
import TokenError from "../components/modals/tokenError";

const Start = () => {
    const {t, lang} = useTranslation()
    const isRTL = lang === 'farsi';
    const router = useRouter()
    const levels = ['Level 1 (Picture & Synonym for English Words)', 'Level 2 (Missing Words in English Sentence)',
        'Level 3 (Missing Words in Farsi Sentence)', 'Level 4 (Synonym for Farsi Words)']
    const levelsFa = ['مرحله ۱ (عکس و مترادف برای لغات انگلیسی)', 'مرحله ۲ (جای‌خالی در جملات انگلیسی)',
        'مرحله ۳ (جای‌خالی در جملات فارسی)', 'مرحله ۴ (مترادف برای لغات فارسی)']
    const [books, setBooks] = useState([]);
    const [lessons, setLessons] = useState([]);

    const [selectedBook, setSelectedBook] = useState({code: null, name: null});
    const [selectedLesson, setSelectedLesson] = useState({code: null, name: null});
    const [selectedType, setSelectedType] = useState(null);
    const [validated, setValidated] = useState({level: false, book: false, lesson: false});
    const [loading, setLoading] = useState(null);
    const [getBooksLoading, setGetBooksLoading] = useState(false);
    const [getLessonsLoading, setGetLessonsLoading] = useState(false);
    const [gameFirstTimeUser, setGameFirstTimeUser] = useState('');
    const defaultSelectedLevel={fa:'مرحله خود را انتخاب کنید',en:'Choose Your Level'}
    const defaultSelectedBook={fa:'کتاب خود را انتخاب کنید',en:'Choose Your Book'}
    const defaultSelectedLesson={fa:'درس خود را انتخاب کنید',en:'Choose Your Lesson'}

    const [show2, setShow2] = useState(false);
    const toggle2 = () => setShow2(!show2);


    useEffect(()=>{
        // localStorage.setItem('CellPhoneNum', CellPhoneNum);
        localStorage.setItem('homeFirstTimeUser', 1);
        const gameFirstTimeUserConst = localStorage.getItem('gameFirstTimeUser');
        // console.log("gameFirstTimeUserConst",gameFirstTimeUserConst)
        if (!gameFirstTimeUserConst || gameFirstTimeUserConst!=='4') {
            localStorage.setItem('gameFirstTimeUser', 0);
            setGameFirstTimeUser(0)
        }else{
            setGameFirstTimeUser(gameFirstTimeUserConst)
        }
    },[]);
    useEffect(() => {
        setSelectedBook({code: null, name: isRTL ? defaultSelectedBook.fa : defaultSelectedBook.en})
        setValidated(prevState => ({...prevState, book: false}))
    }, [selectedType,isRTL])

    useEffect(() => {
        setSelectedLesson({code: null, name: isRTL ? defaultSelectedLesson.fa : defaultSelectedLesson.en})
        setValidated({...validated, lesson: false})
    }, [selectedBook,isRTL])

    const [error, setError] = useState(null);
    const [show, setShow] = useState(false);
    const toggle = () => setShow(!show);

    const startGame = () => {
        const Counter = localStorage.getItem('Counter');
        const Username = localStorage.getItem('Username');
        const token = localStorage.getItem('token');
        //check if user is verified
        if (Username && token) {
            // if validation is passed create and start the game
            if (setValidatedStyle()) {
                setLoading(true);
                createGame(selectedType, selectedBook.code, selectedLesson.id,token)
                    .then(res => {
                        // console.log("createGame res:",res.data)
                        const contestId = res.data
                        setLoading(false);
                        router.push({
                            pathname: '/game',
                            // query: {data: [ selectedType, selectedBook.code, selectedLesson.id,'test', contestId]}
                            query: {data: [Counter, selectedType, selectedBook.code, selectedLesson.id, contestId, 'test', selectedLesson.name]}
                        });


                    }).catch(err => {
                    console.log("createGame error:", {err});
                    setLoading(false);
                });
                localStorage.setItem('gameFirstTimeUser', 4);
                setGameFirstTimeUser(4)
            } else {
                const error = Object.entries(validated).filter((item) => {
                    return !item[1]
                })
                setError(error[0])
                setShow(true)
            }
        } else {
            setError(["login", false])
            setShow(true);
            setLoading(false);
        }
    }

    const setValidatedStyle = () => {
        const isValidated = Object.entries(validated).filter(item => item[1])
        return isValidated.length === 3
    }

    return (
        <Layout page={"start"}>
            <Head>
                <title>{isRTL ? 'شروع - دنیای واژگان' : 'Start - wow kanoon'}</title>
                <link rel="icon" href="/images/logos/favicon.png"/>
            </Head>
            <TokenError show={show2} toggle={toggle2} redirect={'start'}/>
            <ErrorModal error={error} show={show} toggle={toggle} redirect={'start'}/>
            <div className={`d-flex justify-content-center flex-column align-items-center ${styles.start}`}>
                <DropdownGetLevels classes={{bg: styles.first, arrow: styles.firstArrowDown}}
                                   defaultSelected={defaultSelectedLevel}
                                   data={isRTL ? levelsFa : levels}
                                   setBooks={setBooks}
                                   setSelectedType={setSelectedType}
                                   setValidated={setValidated}
                                   setError={setError}
                                   setShow={setShow}
                                   gameFirstTimeUser={gameFirstTimeUser}
                                   setGameFirstTimeUser={setGameFirstTimeUser}
                                   mode={'test'}
                                   setGetBooksLoading={setGetBooksLoading}
                                   setShow2={setShow2}

                />
                <DropDownBooks classes={{
                    bg: selectedType ? styles.second : styles.grey,
                    arrow: selectedType ? styles.secondArrowDown : styles.greyArrowDownLeft
                }}
                               mode={'test'}
                               defaultSelected={defaultSelectedBook}
                               data={books}
                               setLessons={setLessons}
                               setSelectedBook={setSelectedBook}
                               selectedBook={selectedBook}
                               setValidated={setValidated}
                               setError={setError}
                               setShow={setShow}
                               gameFirstTimeUser={gameFirstTimeUser}
                               setGameFirstTimeUser={setGameFirstTimeUser}
                               getBooksLoading={getBooksLoading}
                               setGetLessonsLoading={setGetLessonsLoading}
                               setShow2={setShow2}
                               show2={show2}
                />
                <DropdownLesson
                    classes={{
                        bg: selectedBook && selectedBook.code ? styles.third : styles.grey,
                        arrow: selectedBook && selectedBook.code  ? styles.thirdArrowDown : styles.greyArrowDownRight
                    }}
                    data={lessons}
                    defaultSelected={defaultSelectedLesson}
                    setSelectedLesson={setSelectedLesson}
                    selectedLesson={selectedLesson}
                    setValidated={setValidated}
                    setError={setError}
                    setShow={setShow}
                    gameFirstTimeUser={gameFirstTimeUser}
                    setGameFirstTimeUser={setGameFirstTimeUser}
                    mode={'test'}
                    getLessonsLoading={getLessonsLoading}
                />
                <div className={styles.startWrapper}>
                    {gameFirstTimeUser==3 &&
                    <div className={`${styles.toolTip} ${isRTL ? '' : styles.toolTipEn}`}>
                        <p className={`${styles.toolTipText} ${isRTL ? '' : styles.toolTipTextEn}`}>
                            {t('start:Now you can start the game!')}
                        </p>
                    </div>
                    }
                    <div
                        onClick={loading ? undefined : startGame}
                        className={`${styles.menuItem} ${setValidatedStyle() ? styles.redBg : styles.greyStart} `}>
                        {loading ? (
                            <>
                                <ButtonLoading/>
                                <span>loading</span>
                            </>
                        ) : (
                            <p>{isRTL ? 'شروع' : 'Start'}</p>
                        )}
                    </div>
                </div>

                <img className={styles.missile} src='/images/start/missile.svg'/>
            </div>
            <Footer/>
        </Layout>
    );
};

export default Start;


    export async function getStaticProps(ctx) {
        
        
        return {
          
          props: {
            
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/start',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  